// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderDetailsPageStyles } from "@insite/content-library/Pages/OrderDetailsPage";
import pageErrorWrapperSharedStyle from "@keller/App/PagesExtensions/PageErrorWrapperSharedStyle";

orderDetailsPageStyles.loadFailedWrapper = {
    ...pageErrorWrapperSharedStyle.loadFailedWrapper,
};

orderDetailsPageStyles.loadFailedText = {
    ...pageErrorWrapperSharedStyle.loadFailedText,
};
